export const perPageOptions = [
    { label: '20개 보기', value: 20 },
    { label: '30개 보기', value: 30 },
    { label: '40개 보기', value: 40 },
    { label: '50개 보기', value: 50 }
];